export function awsUrl(){
    const fullUrl = window.location.host
    const parts = fullUrl.split('.')
    const clientShortName = parts[0]
    const app_status = process.env.VUE_APP_STATUS !== undefined ? process.env.VUE_APP_STATUS : 'production'

    let url = ''

    if( app_status == 'localhost')
    {
        url = 'http://127.0.0.1/v3/storage/clients/' + clientShortName + '/'
    } else if( app_status == 'staging' || app_status == 'production' || app_status == 'preprod') {
        const awsUrl = process.env.VUE_APP_AWS_URL !== undefined ? process.env.VUE_APP_AWS_URL : 'https://s3-eu-west-1.amazonaws.com/netsendv3/' + clientShortName + '/'
        url = awsUrl
    }

    return url
}